import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import SiteDisabled from "@/pages/SiteDisabled";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminHub from "@/pages/admin/AdminHub";
import SystemControl from "@/pages/admin/SystemControl";
// CMS
import CmsLayout from "@/pages/admin/cms/CmsLayout";
import CmsDashboard from "@/pages/admin/cms/CmsDashboard";
import CmsSectionEditor from "@/pages/admin/cms/CmsSectionEditor";
import CmsQuotes from "@/pages/admin/cms/CmsQuotes";
// Ops
import OpsLayout from "@/pages/admin/ops/OpsLayout";
import OpsDashboard from "@/pages/admin/ops/OpsDashboard";
import OpsQuotes from "@/pages/admin/ops/OpsQuotes";
import OpsOrders from "@/pages/admin/ops/OpsOrders";
import OpsOrderDetail from "@/pages/admin/ops/OpsOrderDetail";
import OpsInvoices from "@/pages/admin/ops/OpsInvoices";
import OpsInvoiceDetail from "@/pages/admin/ops/OpsInvoiceDetail";

import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { ContentProvider } from "@/contexts/ContentContext";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0A0A0A] text-white/60 font-body">
        Loading…
      </div>
    );
  }
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <ContentProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/admin/login" element={<AdminLogin />} />

              {/* Hub */}
              <Route path="/admin" element={<ProtectedRoute><AdminHub /></ProtectedRoute>} />
              <Route path="/admin/system" element={<ProtectedRoute><SystemControl /></ProtectedRoute>} />

              {/* CMS — landing page editor */}
              <Route path="/admin/cms" element={<ProtectedRoute><CmsLayout /></ProtectedRoute>}>
                <Route index element={<CmsDashboard />} />
                <Route path="quotes" element={<CmsQuotes />} />
                <Route path="section/:key" element={<CmsSectionEditor />} />
              </Route>

              {/* Operations — quotes, orders, invoices */}
              <Route path="/admin/ops" element={<ProtectedRoute><OpsLayout /></ProtectedRoute>}>
                <Route index element={<OpsDashboard />} />
                <Route path="quotes" element={<OpsQuotes />} />
                <Route path="orders" element={<OpsOrders />} />
                <Route path="orders/:id" element={<OpsOrderDetail />} />
                <Route path="invoices" element={<OpsInvoices />} />
                <Route path="invoices/:id" element={<OpsInvoiceDetail />} />
              </Route>

              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
        </ContentProvider>
      </AuthProvider>
      <Toaster
        theme="dark"
        position="top-center"
        toastOptions={{
          style: {
            background: "#1A1A1A",
            border: "1px solid rgba(212,175,55,0.3)",
            color: "#fff",
            fontFamily: "Inter, sans-serif",
          },
        }}
      />
    </div>
  );
}

export default App;
